import { StyledBreadcrumb } from "@aureskonnect/react-ui";
import MessageInfo from "@components/Common/MessageInfo";
import React from "react";
import { useSelector } from "react-redux";

function HeaderApplication({ oneShop, typeDisplay, t }: any) {
    const selectedAccount = useSelector(
        (state: any) => state.global.selectedAccount
    );
    return (
        <div>
            {" "}
            <StyledBreadcrumb
                items={[
                    {
                        item: "Settings".toUpperCase(),
                        link: `${process.env.REACT_APP_PORTAIL_URL}`,
                    },
                    {
                        item: selectedAccount?.toUpperCase() || "",
                        link: oneShop ? "/setting/customer-account" : "/compte",
                    },
                    {
                        item: t("Application").toUpperCase(),
                        link: "applications",
                    },
                    {
                        item: t("KIOSK").toUpperCase(),
                        link: "kiosk",
                    },
                    {
                        item: t(
                            typeDisplay === "notArchived"
                                ? "Peripheral setting"
                                : "Archived peripheral setting"
                        ).toUpperCase(),
                        link: "#",
                    },
                ]}
            />
            <MessageInfo
                message={t(
                    "In this section, you can perform the declaration and configuration of the store's kiosks, as well as peripherals such as printers and electronic payment terminals (TPE)."
                )}
            />
        </div>
    );
}

export default HeaderApplication;
